import { render } from "./BoardingForm.vue?vue&type=template&id=9fa75c3c"
import script from "./BoardingForm.vue?vue&type=script&lang=js"
export * from "./BoardingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__